import React from 'react';

// Hooks
import useRichText from "../../hooks/api/useRichText";
import QuoteIcon from "../quoteIcon/quoteIcon";

function ColorSectionTextQuote({ accentColor, description, title, backgroundColor, quoteText, idx}) {
  const { parseBodyText } = useRichText();
  
  return (
    <section className={`${idx === 0 ? 'pt-48 sm:pt-72 lg:pt-44' : 'pt-48 sm:pt-72 lg:pt-44'} pb-20 sm:pb-24 px-5 sm:px-7 lg:px-20`} style={{ backgroundColor: backgroundColor }}>
      <h6 className={`relative w-full lg:w-3/4 text-5xl sm:text-8xl lg:text-9xl xl:text-13xl pb-6 lg:pb-12 font-bold font-comp uppercase`} style={{ color: accentColor}}>
        {title}
        <span className={'absolute bottom-0 left-0.5 w-11 sm:w-93px lg:w-52 h-1 sm:h-5px lg:h-2.5'} style={{ backgroundColor: accentColor}}></span>
      </h6>
      <div className={'flex flex-wrap justify-between mt-8 sm:mt-20 lg:mt-24'}>
        <div className={'lg:w-6/12 text-lg sm:text-28px lg:text-2xl font-sans text-base-color'}>
          {parseBodyText(description)}
        </div>
        <div className={'mt-10 sm:mt-16 lg:mt-0 lg:w-2/5'}>
          <QuoteIcon color={accentColor}/>
					<div className={'font-medium'} style={{color: accentColor}}>
            {parseBodyText(quoteText)}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ColorSectionTextQuote;
